<template>
  <el-row :gutter="10">
    <el-col :span="14">
      <PackageSizeTable :changeOrderCode="changeOrderCode" :disabled="disabled" />
    </el-col>
    <el-col :span="10">
      <PackageDocTable :changeOrderCode="changeOrderCode" :disabled="disabled" />
    </el-col>
  </el-row>
</template>
<script>
import PackageSizeTable from './components/package-size'
import PackageDocTable from './components/package-doc'
export default {
  components: { PackageSizeTable, PackageDocTable },
  props: {
    changeOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {}
  },
}
</script>
